import React, { Component } from 'react';
import {
  Modal,
  Button,
  Image,
  Segment,
} from 'semantic-ui-react';
import ReactWebcam from 'react-webcam';
import { func } from 'prop-types';

class ModalCapture extends Component {
  state = {
    imageSrc: '',
    step: 1,
    isCameraReady: false,
    meta: {
      width: 640,
      height: 480,
    },
  };

  onCameraReady = () => {
    setTimeout(() => {
      this.setState({
        isCameraReady: true,
      });
    }, 1500);
  };

  setRefWebcam = (webcam) => {
    this.webcam = webcam;
  };

  capturePhoto = () => {
    if (!this.state.isCameraReady) return;
    const meta = {
      width: this.webcam.props.width,
      height: this.webcam.props.height,
    };
    const imageSrc = this.webcam.getScreenshot();
    if (imageSrc) {
      this.setState({
        imageSrc,
        step: 2,
        meta,
      });
    }
  };

  backToTakeImage = () => {
    this.setState({
      step: 1,
      isCameraReady: false,
    });
  };

  sendImage = () => {
    const { imageSrc, meta } = this.state;
    this.props.uploadImage(
      imageSrc,
      meta,
    );
    this.props.toggleModalCapture();
  };

  render() {
    const { imageSrc, step, isCameraReady } = this.state;
    const { toggleModalCapture } = this.props;
    return (
      <Modal
        open
        className="capture"
      >
        <Modal.Header>Capture a photo</Modal.Header>
        <Modal.Content as={Segment} basic loading={!isCameraReady}>
          {
            step === 1
            && (
              <ReactWebcam
                ref={this.setRefWebcam}
                screenshotFormat="image/png"
                onUserMedia={this.onCameraReady}
              />
            )
          }
          {
            step === 2
            && (
              <Image
                src={imageSrc}
              />
            )

          }
        </Modal.Content>
        <Modal.Actions>
          {
            step === 1
            && (
              <Button
                onClick={toggleModalCapture}
              >
                Cancel
              </Button>
            )
          }
          {
            step === 1
            && (
              <Button
                primary
                content="Take Photo"
                onClick={this.capturePhoto}
              />
            )

          }
          {
            step === 2
            && (
              <Button
                onClick={this.backToTakeImage}
              >
                Back
              </Button>
            )

          }
          {
            step === 2
            && (
              <Button
                primary
                content="Send"
                onClick={this.sendImage}
              />
            )

          }
        </Modal.Actions>
      </Modal>
    );
  }
}

ModalCapture.propTypes = {
  toggleModalCapture: func.isRequired,
  uploadImage: func.isRequired,
};

export default ModalCapture;
